"use client";

import React from "react";
import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Webentwicklung
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            IT-Dienstleistungen
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            KI-Automatisierung
          </Link>
        </li>
        <li data-index={3}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Digital Marketing
          </Link>
        </li>
        <li data-index={4}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Social Media Management
          </Link>
        </li>
        <li data-index={5}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            Software-Testing
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="252275" id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="text-primary !h-auto !w-[200px] [&_svg]:text-primary [&_svg]:!h-auto [&_svg]:!w-[200px]" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-xs font-default leading-relaxed">
              Moderne IT- & KI-Lösungen für Unternehmen. Ihr Partner für digitale Exzellenz in Deutschland.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground mb-6 text-lg tracking-tight">Services</h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground mb-6 text-lg tracking-tight">Unternehmen</h3>
            <ul className="space-y-3 mb-8">
              <li data-index={0}>
                <Link to="/impressum-8/" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                  Impressum
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/datenschutz-8/" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
                  Datenschutz
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-4">
              <Link to="https://www.linkedin.com/company/chrotech?trk=blended-typeahead" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="https://www.facebook.com/Ahmedelsayed741/" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://www.instagram.com/chrotech_/" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://www.youtube.com/@ahmedelsayed4207" className="text-muted-foreground hover:text-primary transition-colors" aria-label="YouTube">
                <Youtube className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-muted-foreground text-xs leading-relaxed max-w-4xl font-default">
            CHROTECH – Premium IT-Dienstleistungen & Digital Marketing. Made in Germany.
          </p>
          <p className="text-muted-foreground/60 text-xs shrink-0 font-default">
            &copy; {new Date().getFullYear()} CHROTECH. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </section>;
}